import { useState } from "react";
import TransactionsTab from "./TransactionsTab";
import DailySummaryTab from "./DailySummaryTab";
import RefundTab from "./RefundTab";
import "../../styles/org-management.css";

const TABS = [
  { id: "transactions", label: "Transactions", icon: "🧾" },
  { id: "refunds", label: "Refunds", icon: "↩️" },
  { id: "daily", label: "Daily Summary", icon: "📈" },
] as const;

type TabId = (typeof TABS)[number]["id"];

export default function SalesPage() {
  const [activeTab, setActiveTab] = useState<TabId>("transactions");

  return (
    <div>
      <h1>Sales</h1>
      <p className="page-subtitle">
        View transaction history, process refunds, and daily summaries
      </p>

      <div className="org-mgmt-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`org-mgmt-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            <span>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "transactions" && <TransactionsTab />}
      {activeTab === "refunds" && <RefundTab />}
      {activeTab === "daily" && <DailySummaryTab />}
    </div>
  );
}
